<template>
    <div class="m-question m-question-type-1 relative">
        <div class="m-question--branch relative mx-auto">
            <div class="m-question--branch__vine">
                <div ref="sloth" class="m-question--branch__sloth"></div>
            </div>
        </div>
    </div>
</template>

<script>
import interact from 'interactjs'
export default {
  name: 'QuestionType1',
  data () {
    return {
      slothX: 350
    }
  },
  props: {
    keys: Number
  },
  // watch: {
  //   slothX: {
  //     handler: function (newVal) {
  //       const ele = this.$parent.$refs.answerBar[0]
  //       for (let i = 0; i < ele.children.length; i += 1) {
  //         ele.children[i].classList.remove('_active')
  //       }
  //       // 實際遊玩距離： 30 ~ 680
  //       // 實際軸距 650
  //       // 切分點如下 108.3 354.9 571.5
  //       if (newVal <= 108.3) {
  //         this.$parent.selectAns(this.keys, 0)
  //         ele.children[0].classList.add('_active')
  //       }
  //       if (newVal > 108.3 && newVal <= 354.9) {
  //         this.$parent.selectAns(this.keys, 1)
  //         ele.children[1].classList.add('_active')
  //       }
  //       if (newVal > 354.9 && newVal <= 571.5) {
  //         this.$parent.selectAns(this.keys, 2)
  //         ele.children[2].classList.add('_active')
  //       }
  //       if (newVal > 571.5) {
  //         this.$parent.selectAns(this.keys, 3)
  //         ele.children[3].classList.add('_active')
  //       }
  //     }
  //   }
  // },
  mounted () {
    this.$nextTick(() => {
      // this.slothX = 350
      const self = this
      const ele = this.$refs.sloth
      interact(ele).draggable({
        startAxis: 'x',
        lockAxis: 'x',
        modifiers: [
          interact.modifiers.snap({
            targets: [
              { x: 100, y: 0 }
            ],
            range: 100,
            relativePoints: [
              { x: 0, y: 0 },
              { x: 0.33, y: 0 },
              { x: 0.66, y: 0 },
              { x: 1, y: 0 }
            ]
          }),
          interact.modifiers.restrict({
            restriction: ele.parentNode,
            elementRect: { top: 0, left: -1, bottom: 0, right: 1.75 },
            endOnly: true
          })
        ],
        inertia: true
      })
        .on('dragmove', function (event) {
          self.slothX += event.dx
          event.target.style.webkitTransform = event.target.style.transform = 'translate(' + self.slothX + 'px, 0px)'

          const ele = self.$parent.$refs.answerBar[0]
          for (let i = 0; i < ele.children.length; i += 1) {
            ele.children[i].classList.remove('_active')
          }
          // 實際遊玩距離： 30 ~ 680
          // 實際軸距 650
          // 切分點如下 108.3 354.9 571.5
          if (self.slothX <= 108.3) {
            self.$parent.selectAns(self.keys, 0)
            ele.children[0].classList.add('_active')
          }
          if (self.slothX > 108.3 && self.slothX <= 354.9) {
            self.$parent.selectAns(self.keys, 1)
            ele.children[1].classList.add('_active')
          }
          if (self.slothX > 354.9 && self.slothX <= 571.5) {
            self.$parent.selectAns(self.keys, 3)
            ele.children[2].classList.add('_active')
          }
          if (self.slothX > 571.5) {
            self.$parent.selectAns(self.keys, 5)
            ele.children[3].classList.add('_active')
          }
        })
    })
  }
}
</script>

<style scoped lang="scss">
.m-question {
    display: none;
    @include respond-to('1200') {
      display: block;
      &-type-1{
        bottom: 0px;
        width: 100%;
      }
        &--branch{
            width: 1010px;
            height: 700px;
          &:before{
            content: '';
            position: absolute;
            top:0;
            left: 5px;
            width: 95px;
            height: 100%;
            background: url(~@/assets/ques_obj_branch-left.png)center center/cover no-repeat;
            z-index: 2;
          }
          &:after{
            content: '';
            position: absolute;
            top:0;
            right: 5px;
            width: 95px;
            height: 100%;
            background: url(~@/assets/ques_obj_branch-right.png)center center/cover no-repeat;
            z-index: 0;
          }
          &__vine{
            position: absolute;
            left: 0;
            width: 100%;
            top: 100px;
            height: 40px;
            background: url(~@/assets/ques_obj_vine-1.png)center center/cover no-repeat;
            z-index: 2;
          }
          &__sloth{
            position: absolute;
            top: -0.5px;
            left: 100px;
            width: 130px;
            height: 115px;
            transform: translate3d(350px, 0, 0);
            background: url(~@/assets/ques_obj_sloth-1.png)center center/cover no-repeat;
            touch-action: none
          }
        }
    }
}
</style>
